module.exports = __webpack_public_path__ + "static/mockup-scoreboard-78627e26db618770ec478f0a396b9f8c.png";